import { gql } from "@apollo/client";

export const resentmail = gql`
query resendMail($email:String!){
    resendMail(email:$email){status message}
}
`;